export const iconFontAwesomeClothingFashionGraduationCap = (
	<i className="fa-solid fa-graduation-cap"></i>
);
